<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeSubscriptionStatus
 */
import type { BadgeSubscriptionStatusProps } from '../types/interfaces'

import { useBadgeSubscriptionStatus } from '../composables/use-badge-subscription-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeSubscriptionStatus',
})

const props = defineProps<BadgeSubscriptionStatusProps>()

const {
  color,
  text,
} = useBadgeSubscriptionStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
